export var ACTION_BUTTON_SIZE_MAP = {
  small: 16,
  large: 24
};